var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isSeoVisible
    ? _c("div", { staticClass: "rb-seo-related-links" }, [
        _c("div", { staticClass: "rb-seo-related-links__title" }, [
          _vm._v("\n    " + _vm._s(_vm.title) + "\n  "),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "rb-seo-related-links__container" },
          [
            _vm._l(_vm.categoryLinks, function (categoryLink, index) {
              return _c(
                "a",
                {
                  key: index,
                  staticClass:
                    "rb-seo-related-links__link rb-btn rb-btn--black-outline",
                  attrs: {
                    href: categoryLink["eyewear:categoryRelatedLinkUrl"],
                  },
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(categoryLink["eyewear:categoryRelatedLinkName"]) +
                      "\n      "
                  ),
                ]
              )
            }),
          ],
          2
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }